import {
    COLOR
} from '../../business-const/Color/Color'



export const incluiAnnotationsXaxis = (x, text) => {


    return {
        x: x,
        strokeDashArray: 0,
        borderColor: COLOR().annotationsXaxis/*"#775DD0"*/,
        label: {
            borderColor: COLOR().annotationsXaxis/*"#775DD0"*/,
            style: {
                color: "#fff",
                background: COLOR().annotationsXaxis/*"#775DD0"*/
            },
            text: text
        }
    }
}



//export const incluiAnnotationsYaxis = (y, text) => {


//    return {
//        y: y,
//        //strokeDashArray: 0,
//        borderColor: '#ffffff',//COLOR().annotationsXaxis/*"#775DD0"*/,
//        label: {
//            borderColor: COLOR().annotationsXaxis/*"#775DD0"*/,
//            style: {
//                color: "#fff",
//                background: COLOR().annotationsXaxis/*"#775DD0"*/
//            },
//            text: text
//        }
//    }
//}


export const incluiAnnotationsPoints = (x, y, text) => {

    return {
        x: x,
        y: y,
        marker: {
            size: 5,//8
            fillColor: "#fff",
            strokeColor: COLOR().annotationsPoints,//"red",
            radius: 2,
            cssClass: "apexcharts-custom-class"
        },
        label: {
            borderColor: COLOR().annotationsPoints,//"#FF4560",
            offsetY: 4,
            style: {
                color: "#fff",
                background: COLOR().annotationsPoints,//"#FF4560"
            },
            text: text
        }
    }
}